const LogoSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12" fill="#1677FF" />
      <circle cx="12" cy="12" r="6" fill="white" />
    </svg>
  );
};

export default LogoSvg;
